import { PropsWithChildren } from 'react';
import { useIdentityContext } from '../store/store';
import { getIdentityConfig } from '../config';

export function AuthenticatedRoutesGuard({ children }: PropsWithChildren) {
  const user = useIdentityContext((state) => state.user);

  if (!user) {
    getIdentityConfig().onUnauthenticated();
    return null;
  }

  return children;
}
